import React, { useState } from 'react';
import PageContainer from 'components/PageContainer/PageContainer';
import { IActualizarPass, IFormato, IFormulario, ResetearPass } from 'utils/models/interfaces';
import { tooltips } from 'utils/formData';
import { useError } from 'services/ErrorContext';
import { alturaContainer, anchoMaxLogueado } from 'utils/constants';
import { HowToReg } from '@mui/icons-material';
import { Box } from '@mui/material';
import Formulario from '../Formulario/Formulario';
import { useSearchParams } from 'react-router-dom';
import { actualizarPass, cambiarPass } from 'services/servicioPut';
import { getAuthToken } from 'services/apiUtils';
import { Usuario } from 'utils/models/types';

const ActualizarPass = () => {
  const [mensajeExito, setMensajeExito] = useState('');
  const [searchParams] = useSearchParams();
  const { error, clearError, loading, setError, setLoading } = useError();
  const tokenRecibido = searchParams.get('token');
  const token = getAuthToken();
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario: Usuario = usuarioJSON && JSON.parse(usuarioJSON);

  const datosResetearPass: IFormato<ResetearPass>[] = [
    {
      name: 'Password',
      label: 'Nueva contraseña',
      inputType: 'password',
      adornment: 'password',
      pattern: tooltips.password.pattern,
      tooltip: tooltips.password.tooltip,
      subtituloSeccion: 'Ingresá tu nueva contraseña',
    },
  ];

  const datosFormActualizarPassword: IFormato<IActualizarPass>[] = [
    {
      name: 'PasswordAnterior',
      label: 'Contraseña actual',
      inputType: 'password',
      pattern: tooltips.password.pattern,
      tooltip: tooltips.password.tooltip,
      adornment: 'eye',
      subtituloSeccion: 'Por seguridad, ingresá tu contraseña actual',
      numeroCamposSeccion: 1,
    },
    {
      name: 'NuevoPassword',
      label: 'Nueva contraseña',
      inputType: 'password',
      pattern: tooltips.password.pattern,
      tooltip: tooltips.password.tooltip,
      adornment: 'eye',
      subtituloSeccion: 'Elegí una nueva contraseña',
      numeroCamposSeccion: 1,
    },
    {
      name: 'NuevoPasswordConfirm',
      label: 'Confirmar contraseña',
      inputType: 'password',
      pattern: tooltips.password.pattern,
      tooltip: tooltips.password.tooltip,
      adornment: 'eye',
    },
  ];

  const datosPassword = token ? datosFormActualizarPassword : datosResetearPass;

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();

    if (!token) {
      const requestReseteoPass = {
        Password: data.Password,
        Token: tokenRecibido || '',
      };

      try {
        await actualizarPass(requestReseteoPass, setError, setLoading);
        setMensajeExito('¡Tu contraseña fue actualizada con éxito!');
      } catch (err) {
      }
    } else {
      const requestCambiarPass = {
        IdUsuario: usuario.Id,
        PasswordAnterior: data.PasswordAnterior,
        NuevoPassword: data.NuevoPassword,
      };

      try {
        await cambiarPass(requestCambiarPass, setError, setLoading);
        setMensajeExito('¡Tu contraseña fue modificada con éxito!');
      } catch (error) {
      }
    }
  }

  const handleVolver = () => {
    setMensajeExito('');
  };

  return (
    <PageContainer>
      <Box minHeight={alturaContainer} maxWidth={anchoMaxLogueado} mx="auto">
        <Formulario
          campos={datosPassword}
          titulo={token ? 'Modificar contraseña' : 'Restablecer contraseña'}
          tituloPequenio={true}
          onSubmit={handleSubmit}
          onVolver={handleVolver}
          mensajeExito={mensajeExito}
          mensajeError={error}
          loading={loading}
          iconoBoton={HowToReg}
        />
      </Box>
    </PageContainer>
  );
};

export default ActualizarPass;
